/*
 * Vencord, a modification for Discord's desktop app
 * Copyright (c) 2022 Vendicated and contributors
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/

(window.VencordStyles ??= new Map()).set("src/plugins/_api/memberListDecorators/style.css", {
    name: "src/plugins/_api/memberListDecorators/style.css",
    source: ".vc-member-list-decorators-wrapper {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 0.25em;\n}\n\n.vc-member-list-decorators-wrapper:not(:empty) {\n    /* Margin to match default Discord decorators */\n    margin-left: 0.25em;\n}\n",
    classNames: {},
    dom: null,
});

export default "src/plugins/_api/memberListDecorators/style.css";
